<dw-dynamic-routing-init></dw-dynamic-routing-init>

<div class="dw-splash" *ngIf="showSlashScreen">
    <img src="/assets/pilexos/img/pilexos_logo_with_tagline.jpg" class="dw-splash-logo">
    <!-- <div class="dw-splash-center-div">
        <i class="fa fa-spinner fa-pulse fa-fw fa-4x dw-red"></i><span>Loading...</span>
    </div> -->
</div>
<div [hidden]="showSlashScreen">
    <dw-layout *ngIf="showLayout" [bodyClasses]="themeClasses" [showLogoutMessage]="true" [showLogoutMessageModal]="true">
        <div logo>

        </div>
        <div breadcrumb>

        </div>
        <div topMenu>
            <div class="app-title">
                <div class="alert alert-warning env-message" [hidden]="!environmentMessage">
                    {{environmentMessage}}
                </div>
                <div class="flight-school hand" *ngIf="showSchoolName" (click)="changeFlightSchool()">
                    {{schoolName || 'Anthony\'s Flight School'}}

                    <span title="ODA Flight School" *ngIf="isOdaSchool && isPilexosAdmin" class="ml-1"> <i class="fa fa-building dw-orange"></i> </span>
                </div>
            </div>
        </div>
        <div sideBarTop>
            <div class="breadcrumb-container" style="margin-bottom:0px"
                style2="width:100%;text-align: center;height:45px;background-color:white">
            </div>
        </div>
    </dw-layout>
</div>